import LicenseManagement from "containers/LicenseManagement";
import { useParams } from "react-router-dom";

const LicenseInfoPage = (props) => {
    const { tenant } = useParams();
    return (
        <div className="flex-column-container">
            <div>
                <LicenseManagement></LicenseManagement>
            </div>
        </div>
    );
};

export default LicenseInfoPage;
